import { createSlice } from '@reduxjs/toolkit';

const loadStateFromLocalStorage = (userId) => {
    try {
        const serializedState = localStorage.getItem(`organizationSwitch_${userId}`);
        return serializedState ? JSON.parse(serializedState) : {};
    } catch (error) {
        console.error('Failed to load state from local storage:', error);
        return {};
    }
};

const saveStateToLocalStorage = (userId, state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem(`organizationSwitch_${userId}`, serializedState);
    } catch (error) {
        console.error('Failed to save state to local storage:', error);
    }
};

const organizationSwitchSlice = createSlice({
    name: 'organizationSwitch',
    initialState: {
        organizations: {},
        private: true
    },
    reducers: {
        initializeSwitches: (state, action) => {
            const { userId, organizations } = action.payload;

            if (!state[userId]) {
                state[userId] = loadStateFromLocalStorage(userId) || {
                    private: true,
                    organizations: {}
                };
            }

            if (state[userId].organizations === undefined) {
                state[userId].organizations = {};
            }

            if (state[userId].private === undefined) {
                state[userId].private = true;
            }

            organizations.forEach((org) => {
                if (state[userId].organizations[org.id] === undefined) {
                    state[userId].organizations[org.id] = true;
                }
            });

            saveStateToLocalStorage(userId, state[userId]);
        },
        toggleSwitch: (state, action) => {
            const { userId, orgId, togglePrivate } = action.payload;
            const userState = state[userId] || { organizations: {}, private: false };

            if (togglePrivate !== undefined) {
                userState.private = togglePrivate;

                if (!togglePrivate) {
                    const hasCheckedOrganizations = Object.values(userState.organizations).some(Boolean);
                    if (!hasCheckedOrganizations) {
                        const firstOrgId = Object.keys(userState.organizations)[0];
                        if (firstOrgId) {
                            userState.organizations[firstOrgId] = true;
                        }
                    }
                }
            }

            if (orgId) {
                const isCurrentlyChecked = userState.organizations[orgId];
                userState.organizations[orgId] = !isCurrentlyChecked;

                const hasCheckedOrganizations = Object.values(userState.organizations).some(Boolean);
                if (!hasCheckedOrganizations && !userState.private) {
                    userState.organizations[orgId] = true;
                }
            }

            state[userId] = userState;
            saveStateToLocalStorage(userId, userState);
        }
    }
});

export const { initializeSwitches, toggleSwitch } = organizationSwitchSlice.actions;

export default organizationSwitchSlice.reducer;
